module.exports = __webpack_public_path__ + "img/icon-specifications.a1507c2d.svg";